<template>
  <!--Start normal bookie fluc charts-->
  <apexchart style="padding: 4px" type="line" v-if="raceFlucs && filteredFlucs && !bestOddsArray.length >=1 && !isTip && !scratched" height="25" width="60" ref="chart" :options="flucsOptions" :series="filteredFlucs"></apexchart>
  <apexchart style="padding: 4px" type="line" v-else-if="raceFlucs && filteredFlucs && !bestOddsArray.length >=1 && isTip && !scratched" height="60" width="80%" ref="chart" :options="flucsOptions" :series="filteredFlucs"></apexchart>
  <!--End normal bookie fluc charts-->
  <!--Start DynamicOdds Best Odds fluc charts-->
  <apexchart style="padding: 4px" type="line" v-else-if="bestOddsArray.length >=1 && !isTip && !scratched" height="25" width="60" ref="chart" :options="flucsOptionsBO" :series="filteredFlucsBO"></apexchart>
  <apexchart style="padding: 4px" type="line" v-else-if="bestOddsArray.length >=1 && isTip && !scratched" height="60" width="80%" ref="chart" :options="flucsOptionsBO" :series="filteredFlucsBO"></apexchart>
  <!--End DynamicOdds Best Odds fluc charts-->
</template>

<script>
import { format } from 'date-fns'
import { mapState } from 'vuex'

export default {
  name: 'RunnerFlucs',
  props: {
    tabNo: Number,
    raceFlucs: Object,
    isTip: Boolean,
    scratched: Boolean
  },
  computed: {
    ...mapState(['bestPriceBookiesArrays', 'bestOddsArray']),
    flucsOptions: function () {
      const oldFlucs = this.raceFlucs.competitors.map((b) => {
        return b
      })
      const flucs = oldFlucs.find(f => f.flucs[0]?.tabNo === this.tabNo)
      if (!flucs?.flucs) return
      const timeArray = flucs?.flucs?.map((b) => {
        return format(new Date(b.time), 'HH:mm:ss')
      }).filter(f => f)
      if (timeArray?.length === 1) {
        timeArray[1] = timeArray[0]
      }
      const dates = timeArray || [0]
      const options = {
        chart: {
          animations: {
            enabled: false
          },
          type: 'line',
          width: 100,
          height: 25,
          stroke: {
            curve: 'straight'
          },
          sparkline: {
            enabled: true
          }
        },
        xaxis: {
          categories: dates,
          title: {
            text: 'Time'
          }
        },
        tooltip: {
          enabled: true,
          theme: 'dark',
          fixed: {
            enabled: true,
            position: 'topRight',
            offsetX: 0,
            offsetY: -70
          },
          x: {
            show: true
          },
          marker: {
            show: false
          }
        },
        stroke: {
          width: 2,
          colors: '#5388c4'
        },
        fill: {
          type: 'gradient',
          gradient: {
            type: 'vertical',
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            colorStops: [
              {
                offset: 0,
                color: '#95DA74',
                opacity: 1
              },
              {
                offset: 20,
                color: '#61DBC3',
                opacity: 1
              },
              {
                offset: 40,
                color: '#FAD375',
                opacity: 1
              },
              {
                offset: 60,
                color: '#fab175',
                opacity: 1
              },
              {
                offset: 100,
                color: '#EB656F',
                opacity: 1
              }
            ]
          }
        }
      }
      return options
    },
    flucsOptionsBO: function () {
      let source
      this.bestOddsArray.forEach(b => {
        // eslint-disable-next-line eqeqeq
        if (this.tabNo == b.tabNo) {
          source = b.source
        }
      })
      if (!source) return
      const sourceFlucs = this.bestPriceBookiesArrays.find(f => f.source === source)
      const flucs = sourceFlucs.competitors.find(f => f.flucs[0]?.tabNo === this.tabNo)
      const timeArray = flucs?.flucs?.map((b) => {
        return format(new Date(b.time), 'HH:mm:ss')
      }).filter(f => f)
      if (timeArray?.length === 1) {
        timeArray[1] = timeArray[0]
      }
      const dates = timeArray || [0]
      const options = {
        chart: {
          animations: {
            enabled: false
          },
          type: 'line',
          width: 100,
          height: 25,
          stroke: {
            curve: 'straight'
          },
          sparkline: {
            enabled: true
          }
        },
        xaxis: {
          categories: dates,
          title: {
            text: 'Time'
          }
        },
        tooltip: {
          enabled: true,
          theme: 'dark',
          fixed: {
            enabled: true,
            position: 'topRight',
            offsetX: 0,
            offsetY: -70
          },
          x: {
            show: true
          },
          marker: {
            show: false
          }
        },
        stroke: {
          width: 2,
          colors: '#5388c4'
        },
        fill: {
          type: 'gradient',
          gradient: {
            type: 'vertical',
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            colorStops: [
              {
                offset: 0,
                color: '#95DA74',
                opacity: 1
              },
              {
                offset: 20,
                color: '#61DBC3',
                opacity: 1
              },
              {
                offset: 40,
                color: '#FAD375',
                opacity: 1
              },
              {
                offset: 60,
                color: '#fab175',
                opacity: 1
              },
              {
                offset: 100,
                color: '#EB656F',
                opacity: 1
              }
            ]
          }
        }
      }
      return options
    },
    filteredFlucs: function () {
      const oldFlucs = this.raceFlucs.competitors.map((b) => {
        return b
      })
      const flucs = oldFlucs.find(f => f.flucs[0]?.tabNo === this.tabNo)
      if (!flucs?.flucs) return
      const timeArray = flucs?.flucs.map((b) => {
        return b.price
      }).filter(f => f)
      if (timeArray?.length === 1) {
        timeArray[1] = timeArray[0]
      }
      return [{
        name: 'Odds',
        data: timeArray
      }]
    },
    filteredFlucsBO: function () {
      let source
      this.bestOddsArray.forEach(b => {
        // eslint-disable-next-line eqeqeq
        if (this.tabNo == b.tabNo) {
          source = b.source
        }
      })
      if (!source) return
      const sourceFlucs = this.bestPriceBookiesArrays.find(f => f.source === source)
      const flucs = sourceFlucs.competitors.find(f => f.flucs[0]?.tabNo === this.tabNo)
      const timeArray = flucs?.flucs.map((b) => {
        return b.price
      }).filter(f => f)
      if (timeArray?.length === 1) {
        timeArray[1] = timeArray[0]
      }
      return [{
        name: 'Odds',
        data: timeArray
      }]
    }
  }
}
</script>

<style scoped>

</style>
